// import React, { useEffect, useState } from 'react';
// import './../InstructorInterview/InterviewRequestPage.css';
// import axios from 'axios';
// import { INTERVIEWMANAGEMENT_URL } from '../../Services/courseService';
// import { useNavigate } from 'react-router-dom';
// import { Player } from '@lottiefiles/react-lottie-player';
// import loadingAnimation from '../../Assets/animations/loading.json';

// const InterviewRequestPage = () => {
//   const [formData, setFormData] = useState({
//     userEmail: '',
//     userName: '',
//     topic: '',
//     message: ''
//   });

//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [checkingAttempts, setCheckingAttempts] = useState(true);

//   const userId = localStorage.getItem('userId');
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setFormData(prev => ({
//       ...prev,
//       [e.target.name]: e.target.value
//     }));
//   };

//   useEffect(() => {
//     if (!userId) {
//       navigate('/login');
//       return;
//     }

//     const checkAttemptsAndStatus = async () => {
//       try {
//         const attemptRes = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/attempts/remaining`, {
//           params: { userId }
//         });

//         const responseText = attemptRes.data;

//         if (
//           (responseText.includes("Remaining attempts for user") && responseText.includes(": 0")) ||
//           responseText.includes("No record found for user")
//         ) {
//           navigate('/instructor-interview');
//           return;
//         }
//         const statusRes = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request/status`, {
//           params: { userId }
//         });

//         if (statusRes.data === true) {
//           navigate('/interview-confirmation');
//           return;
//         }

//       } catch (error) {
//         console.error('Error checking attempts or status:', error);
//         navigate('/instructor-interview-request');
//       } finally {
//         setCheckingAttempts(false);
//       }
//     };

//     checkAttemptsAndStatus();
//   }, [navigate, userId]);


//   function getLocalDateTime() {
//     const now = new Date();
//     const pad = (n) => n.toString().padStart(2, '0');

//     const year = now.getFullYear();
//     const month = pad(now.getMonth() + 1);
//     const day = pad(now.getDate());
//     const hours = pad(now.getHours());
//     const minutes = pad(now.getMinutes());
//     const seconds = pad(now.getSeconds());

//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setSuccessMessage('');

//     try {
//       const payload = {
//         ...formData,
//         userId,
//         createdAt: getLocalDateTime()
//       };

//       await axios.post(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request`, payload);
//       setSuccessMessage('Interview request sent successfully!');
//       navigate('/interview-confirmation');
//       setFormData({
//         userEmail: '',
//         userName: '',
//         topic: '',
//         message: ''
//       });
//     } catch (error) {
//       console.error('Error sending request:', error);
//       setSuccessMessage('Failed to send request. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (checkingAttempts) {
//     return <div className="interview-form-container"><p>Checking access...</p></div>;
//   }

//   return (
//     <div className="interview-form-container">
//       <h2 className="interview-form-title">Request a Mock Interview</h2>

//       {loading ? (
//         <div className="loading-lottie">
//           <Player
//             autoplay
//             loop
//             src={loadingAnimation}
//             style={{ height: '200px', width: '200px' }}
//           />
//           <p>Submitting your request...</p>
//         </div>
//       ) : (
//         <form className="interview-form" onSubmit={handleSubmit}>
//           <input
//             type="email"
//             name="userEmail"
//             value={formData.userEmail}
//             onChange={handleChange}
//             placeholder="Your Email"
//             required
//           />
//           <input
//             type="text"
//             name="userName"
//             value={formData.userName}
//             onChange={handleChange}
//             placeholder="Your Name"
//             required
//           />
//           <input
//             type="text"
//             name="topic"
//             value={formData.topic}
//             onChange={handleChange}
//             placeholder="Interview Topic (e.g., Java, React)"
//             required
//           />
//           <textarea
//             name="message"
//             value={formData.message}
//             onChange={handleChange}
//             placeholder="Message or Special Instructions"
//             rows={4}
//           />
//           <button type="submit" disabled={loading}>
//             Request Interview
//           </button>
//           {successMessage && <p className="success-message">{successMessage}</p>}
//         </form>
//       )}
//     </div>
//   );
// };

// export default InterviewRequestPage;

// import React, { useEffect, useState } from 'react';
// import './../InstructorInterview/InterviewRequestPage.css';
// import axios from 'axios';
// import { INTERVIEWMANAGEMENT_URL } from '../../Services/courseService';
// import { useNavigate } from 'react-router-dom';
// import { Player } from '@lottiefiles/react-lottie-player';
// import loadingAnimation from '../../Assets/animations/loading.json';
// import categoriesData from '../AiInterview/AIInterviewUnenrolledCourse/CategoriesData';

// const InterviewRequestPage = () => {
//   const [formData, setFormData] = useState({
//     userEmail: '',
//     userName: '',
//     topic: '',
//     message: ''
//   });

//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [selectedSubcategory, setSelectedSubcategory] = useState('');
//   const [selectedTopic, setSelectedTopic] = useState('');

//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [checkingAttempts, setCheckingAttempts] = useState(true);

//   const userId = localStorage.getItem('userId');
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setFormData(prev => ({
//       ...prev,
//       [e.target.name]: e.target.value
//     }));
//   };

//   useEffect(() => {
//     if (!userId) {
//       navigate('/login');
//       return;
//     }

//     const checkAttemptsAndStatus = async () => {
//       try {
//         const attemptRes = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/attempts/remaining`, {
//           params: { userId }
//         });

//         const responseText = attemptRes.data;

//         if (
//           (responseText.includes("Remaining attempts for user") && responseText.includes(": 0")) ||
//           responseText.includes("No record found for user")
//         ) {
//           navigate('/instructor-interview');
//           return;
//         }

//         const statusRes = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request/status`, {
//           params: { userId }
//         });

//         if (statusRes.data === true) {
//           navigate('/interview-confirmation');
//           return;
//         }

//       } catch (error) {
//         console.error('Error checking attempts or status:', error);
//         navigate('/instructor-interview-request');
//       } finally {
//         setCheckingAttempts(false);
//       }
//     };

//     checkAttemptsAndStatus();
//   }, [navigate, userId]);

//   function getLocalDateTime() {
//     const now = new Date();
//     return now.toISOString().slice(0, 19).replace('T', ' ');
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setSuccessMessage('');

//     try {
//       const payload = {
//         ...formData,
//         userId,
//         topic: selectedTopic,
//         createdAt: getLocalDateTime()
//       };

//       await axios.post(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request`, payload);
//       setSuccessMessage('Interview request sent successfully!');
//       navigate('/interview-confirmation');
//       setFormData({
//         userEmail: '',
//         userName: '',
//         topic: '',
//         message: ''
//       });
//       setSelectedCategory('');
//       setSelectedSubcategory('');
//       setSelectedTopic('');
//     } catch (error) {
//       console.error('Error sending request:', error);
//       setSuccessMessage('Failed to send request. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const subcategories = categoriesData.find(cat => cat.title === selectedCategory)?.subcategories || [];
//   const topics = subcategories.find(sub => sub.title === selectedSubcategory)?.popularTopics || [];

//   if (checkingAttempts) {
//     return <div className="interview-form-container"><p>Checking access...</p></div>;
//   }

//   return (
//     <div className="interview-form-container">
//       <h2 className="interview-form-title">Request a Mock Interview</h2>

//       {loading ? (
//         <div className="loading-lottie">
//           <Player
//             autoplay
//             loop
//             src={loadingAnimation}
//             style={{ height: '200px', width: '200px' }}
//           />
//           <p>Submitting your request...</p>
//         </div>
//       ) : (
//         <form className="interview-form" onSubmit={handleSubmit}>
//           <input
//             type="email"
//             name="userEmail"
//             value={formData.userEmail}
//             onChange={handleChange}
//             placeholder="Your Email"
//             required
//           />
//           <input
//             type="text"
//             name="userName"
//             value={formData.userName}
//             onChange={handleChange}
//             placeholder="Your Name"
//             required
//           />

//           <select value={selectedCategory} onChange={e => {
//             setSelectedCategory(e.target.value);
//             setSelectedSubcategory('');
//             setSelectedTopic('');
//           }} required>
//             <option value="">Select Category</option>
//             {categoriesData.map((cat, index) => (
//               <option key={index} value={cat.title}>{cat.title}</option>
//             ))}
//           </select>

//           <select
//             value={selectedSubcategory}
//             onChange={e => {
//               setSelectedSubcategory(e.target.value);
//               setSelectedTopic('');
//             }}
//             disabled={!selectedCategory}
//             required
//           >
//             <option value="">Select Subcategory</option>
//             {subcategories.map((sub, index) => (
//               <option key={index} value={sub.title}>{sub.title}</option>
//             ))}
//           </select>


//           <textarea
//             name="message"
//             value={formData.message}
//             onChange={handleChange}
//             placeholder="Message or Special Instructions"
//             rows={4}
//           />

//           <button type="submit" disabled={loading || !selectedTopic}>
//             Request Interview
//           </button>
//           {successMessage && <p className="success-message">{successMessage}</p>}
//         </form>
//       )}
//     </div>
//   );
// };

// export default InterviewRequestPage;


import React, { useEffect, useState } from 'react';
import './../InstructorInterview/InterviewRequestPage.css';
import axios from 'axios';
import { INTERVIEWMANAGEMENT_URL } from '../../Services/courseService';
import { useNavigate } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import loadingAnimation from '../../Assets/animations/loading.json';
import categoriesData from '../AiInterview/AIInterviewUnenrolledCourse/CategoriesData';

const InterviewRequestPage = () => {
    const [formData, setFormData] = useState({
        userEmail: '',
        userName: '',
        preferredDateTime: '',
        mobileNumber: ''
    });

    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubcategory, setSelectedSubcategory] = useState('');
    const [selectedTopic, setSelectedTopic] = useState('');

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [checkingAttempts, setCheckingAttempts] = useState(true);

    const userId = localStorage.getItem('userId');
    const navigate = useNavigate();

    console.log(localStorage.getItem('fullName'))

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const isValidPreferredTime = (datetime) => {
        if (!datetime) return false;
        const selected = new Date(datetime);
        const now = new Date();
        const diff = selected.getTime() - now.getTime();
        return diff >= 24 * 60 * 60 * 1000;
    };

    useEffect(() => {
        if (!userId) {
            navigate('/login');
            return;
        }

        const checkAttemptsAndStatus = async () => {
            try {
                const attemptRes = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/attempts/remaining`, {
                    params: { userId }
                });

                const responseText = attemptRes.data;

                if (
                    (responseText.includes("Remaining attempts for user") && responseText.includes(": 0")) ||
                    responseText.includes("No record found for user")
                ) {
                    navigate('/instructor-interview');
                    return;
                }

                const statusRes = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request/status`, {
                    params: { userId }
                });

                if (statusRes.data === true) {
                    navigate('/interview-confirmation');
                    return;
                }

            } catch (error) {
                console.error('Error checking attempts or status:', error);
                navigate('/instructor-interview-request');
            } finally {
                setCheckingAttempts(false);
            }
        };

        checkAttemptsAndStatus();
    }, [navigate, userId]);

    function getLocalDateTime() {
        const now = new Date();
        return now.toISOString().slice(0, 19).replace('T', ' ');
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccessMessage('');

        if (!isValidPreferredTime(formData.preferredDateTime)) {
            setSuccessMessage('Preferred time must be at least 24 hours from now.');
            setLoading(false);
            return;
        }

        const { preferredDateTime, mobileNumber } = formData;
        const mobilePattern = /^[6-9]\d{9}$/;
        if (!preferredDateTime || !selectedCategory || !selectedSubcategory || !selectedTopic) {
            setSuccessMessage('Please fill all the fields.');
            setLoading(false);
            return;
        }
        if (!mobilePattern.test(mobileNumber)) {
            setSuccessMessage('Invalid mobile number. It must be 10 digits starting with 6–9.');
            setLoading(false);
            return;
        }

        try {
            const payload = {
                userId,
                userEmail: localStorage.getItem('email'),
                userName: localStorage.getItem('fullName'),
                category: selectedCategory,
                subCategory: selectedSubcategory,
                topic: selectedTopic,
                preferredTime: formData.preferredDateTime,
                createdAt: getLocalDateTime(),
                mobileNumber: formData.mobileNumber
            };

            await axios.post(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/request`, payload);
            setSuccessMessage('Interview request sent successfully!');
            navigate('/interview-confirmation');

            setFormData({
                userEmail: '',
                userName: '',
                preferredDateTime: ''
            });
            setSelectedCategory('');
            setSelectedSubcategory('');
            setSelectedTopic('');
        } catch (error) {
            console.error('Error sending request:', error);
            setSuccessMessage('Failed to send request. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const subcategories = categoriesData.find(cat => cat.title === selectedCategory)?.subcategories || [];
    const topics = subcategories.find(sub => sub.title === selectedSubcategory)?.popularTopics || [];

    if (checkingAttempts) {
        return <div className="interview-form-container"><p>Checking access...</p></div>;
    }

    return (
        <div className="interview-form-container">
            <h2 className="interview-form-title">Request a Mock Interview</h2>

            {loading ? (
                <div className="loading-lottie">
                    <Player
                        autoplay
                        loop
                        src={loadingAnimation}
                        style={{ height: '200px', width: '200px' }}
                    />
                    <p>Submitting your request...</p>
                </div>
            ) : (
                <form className="interview-form" onSubmit={handleSubmit}>

                    <label style={{ marginTop: '10px', fontWeight: '500' }}>Mobile Number:</label>
                    <input
                        type="tel"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        placeholder="Enter 10-digit Indian mobile number"
                        pattern="[6-9]{1}[0-9]{9}"
                        maxLength="10"
                        required
                    />


                    <select value={selectedCategory} onChange={e => {
                        setSelectedCategory(e.target.value);
                        setSelectedSubcategory('');
                        setSelectedTopic('');
                    }} required>
                        <option value="">Select Category</option>
                        {categoriesData.map((cat, index) => (
                            <option key={index} value={cat.title}>{cat.title}</option>
                        ))}
                    </select>

                    <select
                        value={selectedSubcategory}
                        onChange={e => {
                            setSelectedSubcategory(e.target.value);
                            setSelectedTopic('');
                        }}
                        disabled={!selectedCategory}
                        required
                    >
                        <option value="">Select Subcategory</option>
                        {subcategories.map((sub, index) => (
                            <option key={index} value={sub.title}>{sub.title}</option>
                        ))}
                    </select>

                    <select
                        value={selectedTopic}
                        onChange={e => setSelectedTopic(e.target.value)}
                        disabled={!selectedSubcategory}
                        required
                    >
                        <option value="">Select Topic</option>
                        {topics.map((topic, index) => (
                            <option key={index} value={topic}>{topic}</option>
                        ))}
                    </select>

                    <label style={{ marginTop: '10px', fontWeight: '500' }}>Preferred Interview Time:</label>
                    <input
                        type="datetime-local"
                        name="preferredDateTime"
                        value={formData.preferredDateTime}
                        onChange={handleChange}
                        required
                    />
                    {formData.preferredDateTime && !isValidPreferredTime(formData.preferredDateTime) && (
                        <p style={{ color: 'red', fontSize: '14px' }}>
                            Please select a time at least 24 hours from now.
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={
                            loading ||
                            !selectedTopic ||
                            !formData.preferredDateTime ||
                            !isValidPreferredTime(formData.preferredDateTime)
                        }
                    >
                        Request Interview
                    </button>
                    {successMessage && <p className="success-message">{successMessage}</p>}
                </form>
            )}
        </div>
    );
};

export default InterviewRequestPage;
